import React, { useEffect } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import styles from './app.styles'
import injectSheet from 'react-jss'
import {
  UserProvider,
  UserInspector,
  useMe
} from 'pobble-components/dist/pobble-user'
import AssessementFile from '../pages/assessment-file/assessment-file'
import Moderation from '../pages/moderation/moderation.container'
import EnvironmentLine from 'pobble-components/dist/environment-line'
import Header from 'pobble-components/dist/pobble-header'
import PageNotFound from 'pobble-components/dist/page-not-found'
import { SubscriptionProvider } from 'pobble-components/dist/subscriptions'
import { ToastContainer } from 'pobble-components/dist/toast'
import posthog from 'posthog-js'

const APP_ROOT = process.env.REACT_APP_APP_ROOT || ''
const APP_PATH = process.env.REACT_APP_PATH || '/'

function PostHogIdentity() {
  const { me } = useMe()

  useEffect(() => {
    if (me) {
      const account = me.account
      posthog.identify(account.id)
      posthog.capture('landed on moderation spa', {
        url: window.location.href
      })
    }
  }, [me])

  return null
}

const App = ({ me, meError }) => {
  return (
    <UserProvider
      fetchMe={() => (me ? Promise.resolve(me) : Promise.reject(meError))}>
      <PostHogIdentity />
      <SubscriptionProvider>
        <EnvironmentLine />
        <Header activePage="moderation" appUrl={APP_ROOT} />
        <UserInspector>
          <Router basename={APP_PATH}>
            <Switch>
              <Route
                exact
                path="/assessment-files/:assessmentFileId"
                component={AssessementFile}
              />
              <Route
                exact
                path="/assessment-files/:assessmentFileId/works"
                component={AssessementFile}
              />
              <Route
                exact
                path="/assessment-files/:assessmentFileId/works/:workId"
                component={AssessementFile}
              />
              <Route
                exact
                path={[
                  '/',
                  '/invitations',
                  '/invitations/archived',
                  '/my-files',
                  '/my-files/archived',
                  '/school',
                  '/examples',
                  '/writing-samples',
                  '/trainings',
                  '/local-authority',
                  '/support',
                  '/work-with-a-moderator'
                ]}
                component={Moderation}
              />
              <Route component={PageNotFound} />
            </Switch>
          </Router>
        </UserInspector>
        <ToastContainer />
      </SubscriptionProvider>
    </UserProvider>
  )
}

export default injectSheet(styles)(App)
